module.exports = __webpack_public_path__ + "static/media/jack_ma.56831f88.PNG";